export enum TurnoverPunchFields {
  DueDate = 'DueDate',
  Priority = 'Priority',
  Title = 'Title',
  Description = 'Description',
  Attachment = 'Attachment',
  Unit = 'Unit',
}
